<template>
  <div class="">
    <div class="box">
      <Navigation :route="navigationRoute" class="mb-10"></Navigation>

      <div class="flex-wrap" style="gap: 24px;">
        <div class="course-item" v-for="item in tableData.records" @click="handleDetail('/live/detail', item.id, item.liveId)">
          <img :src="item.xct ? item.xct : require('@/assets/images/defaultImg.jpg')" alt="">
          <div class="coure-info">
            <div class="course-title two-row">
              {{ item.title }}
            </div>
            <div class="course-desc">主讲人：{{ item.teacherName }}</div>
          </div>
          <div class="status-tag" :class="getStatusClass(item)">{{ getStatusText(item) }}</div>
      </div>
    </div>

     <el-pagination @current-change="handleCurrentChange" background :current-page.sync="query.current"
        :page-size="12" layout="prev, pager, next, jumper" :total="tableData.total">
    </el-pagination>
    </div>

   
  </div>
</template>

<script>
import { getLives } from '@/api/index';
import Navigation from "@/components/Navigation.vue";

export default {
  components: {
    Navigation
  },
  data () {
    return {
      navigationRoute: [
        { name: '首页' },
        { name: '精品直播' },
      ],
      info: {},
      query: {
          current: 1,
          size: 12
      },
      tableData: { //表格数据
          total: 0,
          records: []
      },
    };
  },
  created () {
    this.getList()
  },
  methods: {
    handleCurrentChange(val) {
      this.query.current = val
      this.getList()
    },
    getList() {
      getLives(this.query).then(res => {
        console.log(res);
        this.tableData.records = res.records
        this.tableData.total = res.total
      });
    },
    handleDetail(url, id, liveId) {
      this.$router.push({ path: url + '?id=' + id + '&liveId=' + liveId })
    },
    getStatusClass(item) {
      const now = new Date().getTime();
      const startTime = new Date(item.startTime).getTime();
      const endTime = new Date(item.endTime).getTime();
      
      if (now < startTime) {
        return 'status-not-started';
      } else if (now >= startTime && now <= endTime) {
        return 'status-in-progress';
      } else {
        return 'status-ended';
      }
    },
    getStatusText(item) {
      const now = new Date().getTime();
      const startTime = new Date(item.startTime).getTime();
      const endTime = new Date(item.endTime).getTime();
      
      if (now < startTime) {
        return '未开始';
      } else if (now >= startTime && now <= endTime) {
        return '进行中';
      } else {
        return '已结束';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  padding: 24px;
  background: #FFFFFF;
  margin-bottom: 20px;
}

.course-item {
  position: relative;
  width: calc((100% - 72px) / 4);
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #EEEEEE;
  cursor: pointer;

  &:hover {
    transition: all 0.3s ease;
    transform: scale(1.05);
  }

  img {
    display: block;
    width: 100%;
    height: 152px;
    border-radius: 5px 5px 5px 5px;
  }

  .coure-info {
    padding: 10px 10px 15px 10px;

    .course-title {
      font-size: 16px;
      color: #1A1A1A;
      line-height: 24px;
      margin-bottom: 10px;
    }

    .course-desc { 
      font-size: 14px;
      color: #767676;
      line-height: 14px;
    }

    .course-tip {
      width: 67px;
      line-height: 22px;
      background: #EEEEEE;
      border-radius: 4px 4px 4px 4px;

      font-size: 12px;
      text-align: center;
    }
  }
}

.status-tag {
  padding: 6px 9px;
  border-radius: 0px 5px 0px 15px;
  border-left: 1px solid #FFFFFF;
  border-bottom: 1px solid #FFFFFF;
  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 14px;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 999;
}

.status-not-started {
  background: linear-gradient( 180deg, #0CB8FF 0%, #0B92FF 100%);
}

.status-in-progress {
  background: linear-gradient( 180deg, #FFAD0D 0%, #FF930C 100%);
}

.status-ended {
  background: #9C9C9C;
}

</style>
